import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // 樣式化文字輸出
    console.log(
      '%c我看你骨骼驚奇，有著天縱之資，是個學資安的人才，該報名APCSS Camp了吧？',
      'color: #60a5fa; font-size: 24px; font-weight: bold; background: #e6f0fa; padding: 10px; border-radius: 5px;'
    );
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${id}`;
      return;
    }
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 w-full bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/80 backdrop-blur-sm z-50"
    >
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-[#60a5fa]">APCSS Camp</Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('courses')} className="text-[#1e293b] hover:text-[#60a5fa] transition-colors">
              課程活動
            </button>
            <button onClick={() => scrollToSection('past')} className="text-[#1e293b] hover:text-[#60a5fa] transition-colors">
              過往紀錄
            </button>
            <button onClick={() => scrollToSection('registration')} className="text-[#1e293b] hover:text-[#60a5fa] transition-colors">
              報名資訊
            </button>
            <button
              onClick={() => scrollToSection('registration')}
              className="bg-[#60a5fa] text-[#f9fafb] px-6 py-2 rounded-md font-semibold shadow-md hover:bg-[#93c5fd] transition-colors"
            >
              立即報名
            </button>
          </div>
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <XMarkIcon className="h-6 w-6 text-[#1e293b]" /> : <Bars3Icon className="h-6 w-6 text-[#1e293b]" />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="md:hidden bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/80 backdrop-blur-sm"
        >
          <button
            onClick={() => scrollToSection('courses')}
            className="block w-full text-left px-4 py-2 text-[#1e293b] hover:bg-[#e0e7ff]/50 hover:text-[#60a5fa] transition-colors"
          >
            課程活動
          </button>
          <button
            onClick={() => scrollToSection('past')}
            className="block w-full text-left px-4 py-2 text-[#1e293b] hover:bg-[#e0e7ff]/50 hover:text-[#60a5fa] transition-colors"
          >
            過往紀錄
          </button>
          <button
            onClick={() => scrollToSection('registration')}
            className="block w-full text-left px-4 py-2 text-[#1e293b] hover:bg-[#e0e7ff]/50 hover:text-[#60a5fa] transition-colors"
          >
            報名資訊
          </button>
          <button
            onClick={() => scrollToSection('registration')}
            className="block w-full text-left px-4 py-2 bg-[#60a5fa] text-[#f9fafb] font-semibold hover:bg-[#93c5fd] transition-colors"
          >
            立即報名
          </button>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;